import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'underscore';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { THEME_MODE_KEY_MAPPING } from '@bingads-webui-campaign-react/smart-component-util';
import { withErrorView } from '@bingads-webui-campaign-react/smart-page-error-boundary';

import { getDataProperties } from './data-config';

const getStyles = (components, { palette = {} }) => ({
  socialLinksContainer: {
    ...components.section,
    textAlign: 'center',
  },
  link: {
    width: 115,
    margin: '0px 18px 8px 18px',
    display: 'inline-block',
    ...components.link,
    '&:focus': {
      outline: '1px solid #605e5c',
    },
  },
  linkIcon: {
    width: 32,
    height: 32,
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    ...(palette.mode === THEME_MODE_KEY_MAPPING.Dark ? { filter: 'brightness(0) invert(1)' } : {}),
  },
  linkTips: {
    color: palette.linkText,
    textDecoration: 'underline',
    marginTop: 12,
    display: 'block',
    fontSize: 16,
    lineHeight: '20px',
  },
});

const transformLinkUrl = (originalLink) => {
  const httpsPrefix = 'https://';
  const httpPrefix = 'http://';
  if (originalLink.indexOf(httpsPrefix) === 0 || originalLink.indexOf(httpPrefix) === 0) {
    return originalLink;
  }
  return `${httpsPrefix}${originalLink}`;
};

const UnStyledSmartSocialLinksView = ({
  classes,
  i18n,
  id,
  socialLinksConfigs,
}) => {
  const dataProperties = getDataProperties(i18n);
  const socialLinks = [];

  Object.entries(dataProperties).forEach(([, socialLinkMapping]) => {
    const socialLinkConfigs = socialLinksConfigs[socialLinkMapping.key];

    if (socialLinkConfigs.isDisplay) {
      socialLinks.push((
        <a
          className={classNames(classes.link, socialLinkMapping.className)}
          href={transformLinkUrl(socialLinkConfigs.value)}
          key={socialLinkMapping.key}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className={classes.linkIcon} src={socialLinkMapping.logo} alt="" />
          <span className={classes.linkTips}>{socialLinkMapping.label}</span>
        </a>
      ));
    }
  });

  return (
    isEmpty(socialLinks) ? null :
      (
        <div id={id} className={classNames(classes.socialLinksContainer, 'smart-page-social-links-view-container')}>
          <div className={classes.socialLinksSection}>
            {socialLinks}
          </div>
        </div>
      )
  );
};

UnStyledSmartSocialLinksView.propTypes = {
  classes: PropTypes.shape({
    socialLinksContainer: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  id: PropTypes.string,
  socialLinksConfigs: PropTypes.shape({}).isRequired,
};

UnStyledSmartSocialLinksView.defaultProps = {
  id: undefined,
};

export const SmartSocialLinksView = withErrorView(withDefaultStyles(
  UnStyledSmartSocialLinksView,
  getStyles
), 'componentMode');
